import React, { useState, useEffect } from 'react';
import './Result_coming.css';

const Result_coming = () => {
  const resultDate = new Date('2026-02-18T20:10:20');
  
  const calculateTimeLeft = () => {
    const difference = +resultDate - +new Date();
    
    if (difference > 0) {
      return {
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
    return { hours: 0, minutes: 0, seconds: 0 };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);



  return (
    <div className="result-coming-soon">
      <div className="result-overlay"></div>
      <div className="result-content">
        <h1 className='result-counter-title'>RESULTS WILL BE ANNOUNCED IN </h1>
        {Object.keys(timeLeft).length ? (
          <div className="result-countdown-container">
            <div className="result-flip-box">
              <div className="result-flip-card">{timeLeft.hours.toString().padStart(2, '0')}</div>
              <span className="result-label">HOURS</span>
            </div>
            <div className="result-time-sep">:</div>
            <div className="result-flip-box">
              <div className="result-flip-card">{timeLeft.minutes.toString().padStart(2, '0')}</div>
              <span className="result-label">MINUTES</span>
            </div>
            <div className="result-time-sep">:</div>
            <div className="result-flip-box">
              <div className="result-flip-card">{timeLeft.seconds.toString().padStart(2, '0')}</div>
              <span className="result-label">SECONDS</span>
            </div>
          </div>
        ) : (
          <div className="result-message">Results are now available!</div>
        )}
      </div>
    </div>
  );
};

export default Result_coming;